<template>
  <div>
    <div class="p-3">
      <div class="breadcrumb-area pos-relative w-100">
        <h1>Chi tiết tài khoản</h1>
        <div class="btn-group float-right">
          <button
            type="button"
            class="font-medium btn btn-outline-secondary"
            @click="$router.push('/list-agent-partner')"
          >
            <i class="bx bx-exit"></i> Quay lại
          </button>
          <button
            v-if="
              dataPermission && dataPermission.includes('CNPS_AGENT_PARTNER_BANK_UPDATE_KEEPER')
            "
            @click="openPopupDeploymentStaff"
            class="btn font-medium btn-outline-secondary"
          >
            <i class="bx bx-user"></i><span>&nbsp;</span>Chuyển người phụ trách
          </button>
          <button
            v-if="dataPermission && dataPermission.includes('CNPS_AGENT_PARTNER_BANK_VERIFY')"
            @click="$router.push('/list-agent-partner-edit/' + entryId)"
            class="btn font-medium btn-outline-secondary"
          >
            <i class="bx bx-edit"></i><span>&nbsp;</span>Cập nhật
          </button>
          <button
            v-if="dataDetail?.verifyStatus === 'VERIFIED'"
            class="btn font-medium btn-outline-secondary"
            @click="showUnverifyModal"
          >
            <i class="bx bx-x-circle"></i><span>&nbsp;</span>Bỏ xác thực
          </button>
          <button
            v-if="dataDetail?.verifyStatus === 'UNVERIFIED'"
            class="btn font-medium btn-outline-secondary"
            @click="showVerifyModal"
          >
            <i class="bx bx-check-circle"></i><span>&nbsp;</span>Xác thực
          </button>
        </div>
      </div>
      <div class="p-10 pt-15 b-t-1-869fb229">
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-detail">
              <h1 class="form-inner-heading mb-1">Thông tin tài khoản</h1>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Tên tài khoản <span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ dataDetail?.name }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Số điện thoại <span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ dataDetail?.mobile }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Email<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ dataDetail?.email }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Mã Agent<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ dataDetail?.agentId }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Cấp độ<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">Cấp {{ dataDetail?.level }}</p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Trạng thái<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    <span
                      class="badge"
                      :class="`badge-${transformColor(dataDetail?.stateAgent, statusOptions)}`"
                    >
                      {{ dataDetail?.stateAgent | transformData(statusOptions) }}
                    </span>
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Tỉnh/Thành phố<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ dataDetail?.cityName }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Quận/Huyện<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ dataDetail?.districtName }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Địa chỉ chi tiết<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ dataDetail?.address }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Quản lý bởi<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ dataDetail?.managerName || '' }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Thời gian tạo<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ formatDate(dataDetail?.createdDate) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-detail">
              <h1 class="form-inner-heading mb-1">Phụ trách</h1>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Tên người phụ trách - Email<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{
                      dataDetail?.keeper &&
                      dataDetail?.keeper?.name + ' - ' + dataDetail?.keeper?.email
                    }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Vùng<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ dataDetail?.keeper?.regionName }}
                  </p>
                </div>
              </div>

              <h1 class="form-inner-heading mb-1 mt-4">Thông tin hợp đồng & hóa đơn</h1>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Mã hợp đồng<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ dataDetail?.verifyAgentBankInfo?.contractCode || '' }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  File hợp đồng<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <div class="">
                    <div
                      v-if="
                        dataDetail?.verifyAgentBankInfo?.linkContract &&
                        dataDetail?.verifyAgentBankInfo?.linkContract.length > 0
                      "
                      class="contract-files-container ml-2"
                    >
                      <div class="row">
                        <div
                          v-for="(link, index) in dataDetail?.verifyAgentBankInfo?.linkContract"
                          :key="index"
                          class="col-md-5 mb-3 px-1"
                        >
                          <div class="contract-file-card">
                            <div class="file-icon">
                              <i
                                class="bx bxs-file-pdf text-primary"
                                style="font-size: 32px; text-align: center"
                              ></i>
                            </div>
                            <div class="file-info">
                              <div class="d-flex align-items-start">
                                <div>
                                  <p class="file-name">Hợp đồng {{ index + 1 }}</p>
                                  <a :href="link" target="_blank">
                                    <i class="fa fa-eye mr-1"></i> Xem file
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="no-files-container">
                      <div class="placeholder-box">
                        <i class="fa fa-file-o placeholder-icon"></i>
                        <p class="mt-2">Chưa có file hợp đồng</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Tên người nhận tt hóa đơn<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ dataDetail?.verifyAgentBankInfo?.nameReceiveNoticeInvoice || '' }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Email nhận tt hóa đơn<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ dataDetail?.verifyAgentBankInfo?.emailReceiveNoticeInvoice || '' }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  SĐT nhận tt hóa đơn<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ dataDetail?.verifyAgentBankInfo?.mobileReceiveNoticeInvoice || '' }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Hình thức nhận hóa đơn<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{
                      dataDetail?.verifyAgentBankInfo?.typeReceiveNoticeInvoice
                        | transformData(Config.typeReceiveNoticeInvoice)
                    }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Mã số thuế<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ dataDetail?.verifyAgentBankInfo?.taxCode || '' }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Tên công ty / cá nhân<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ dataDetail?.verifyAgentBankInfo?.name || '' }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Địa chỉ công ty / cá nhân<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ dataDetail?.verifyAgentBankInfo?.address || '' }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-xac-thuc" title="Xác nhận" hide-footer>
      <div class="text-left mb-3">
        <h5>{{ modalTitle }}</h5>
        <p>{{ modalMessage }}</p>
      </div>
      <div class="d-flex justify-content-end mt-4">
        <button class="btn btn-secondary mr-2" @click="$bvModal.hide('modal-xac-thuc')">Hủy</button>
        <button class="btn btn-primary" @click="confirmAction">Xác nhận</button>
      </div>
    </b-modal>

    <b-modal id="modal-notification" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img v-if="isSuccess" src="@/assets/img/noti-success2.svg" alt="icon-successs" />
        <img v-else src="@/assets/img/noti-unsuccess2.svg" alt="icon-successs" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <developmentStaff
      title="Gán nhân viên chăm sóc đối tác"
      ref="developStaff"
      :showListStaff="showListStaff"
      @submit="assignSelectedStaff"
      @close="showListStaff = false"
    >
    </developmentStaff>

    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'
  import { AgentService } from '@/services/agent.service'
  import developmentStaff from '@/pages/potential_customers/AssignModal/developmentStaff.vue'

  export default {
    components: {
      developmentStaff,
    },
    data() {
      return {
        item: null,
        entryId: this.$route.params.id,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        loading: false,
        Config,
        dataDetail: {},
        statusOptions: [...Config.statusOptionsAgentPartner],
        showListStaff: false,
        showLoading: false,
        modalTitle: '',
        modalMessage: '',
        actionType: '', // 'verify' hoặc 'unverify',
        dataSale: [],
        isSuccess: true,
      }
    },
    created() {
      this.fetchData()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },

    methods: {
      openPopupDeploymentStaff() {
        this.showListStaff = true
      },
      transformColor(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].color
      },

      async assignSelectedStaff(data) {
        this.selectedStaff = data.userId.length > 0 ? data.userId[0] : ''
        this.dataSale = data.dataSale
        this.showListStaff = false
        this.showLoading = true
        await this.assignDeploymentStaff()
      },

      async assignDeploymentStaff() {
        try {
          this.showLoading = true
          const response = await AgentService.assignDeploymentStaff({
            id: this.entryId,
            keeperId: this.selectedStaff,
          })

          if (response.code === 1000) {
            // Thiết lập thông báo thành công
            this.isSuccess = true
            this.msgNoti = `Đã chuyển người phụ trách thành công`
            this.notiModal = true

            await this.fetchData()

            setTimeout(() => {
              this.notiModal = false
            }, 1500)
          } else {
            // Thiết lập thông báo lỗi
            this.isSuccess = false
            this.msgNoti = response.message || 'Có lỗi xảy ra, vui lòng thử lại sau.'
            this.notiModal = true
          }
        } catch (error) {
          console.log(error)
          // Thiết lập thông báo lỗi khi có exception
          this.isSuccess = false
          this.msgNoti = 'Có lỗi xảy ra, vui lòng thử lại sau.'
          this.notiModal = true
        } finally {
          this.showLoading = false
        }
      },
      showVerifyModal() {
        this.modalTitle = 'Xác thực tài khoản'
        this.modalMessage = 'Bạn có chắc chắn muốn xác thực tài khoản này?'
        this.actionType = 'verify'
        this.$bvModal.show('modal-xac-thuc')
      },

      showUnverifyModal() {
        this.modalTitle = 'Bỏ xác thực tài khoản'
        this.modalMessage = 'Bạn có chắc chắn muốn bỏ xác thực tài khoản này?'
        this.actionType = 'unverify'
        this.$bvModal.show('modal-xac-thuc')
      },

      async confirmAction() {
        try {
          this.loading = true
          this.$bvModal.hide('modal-xac-thuc')

          let res
          if (this.actionType === 'verify') {
            res = await AgentService.verifyAgentPartner(this.entryId)
          } else {
            res = await AgentService.verifyAgentPartner(this.entryId)
          }

          if (res.code === 1000) {
            // Hiển thị modal thông báo thành công
            this.isSuccess = true
            this.msgNoti =
              this.actionType === 'verify'
                ? 'Xác thực tài khoản thành công!'
                : 'Bỏ xác thực tài khoản thành công!'
            this.notiModal = true

            this.fetchData() // Tải lại dữ liệu sau khi cập nhật
          } else {
            // Hiển thị modal thông báo lỗi
            this.isSuccess = false
            this.msgNoti = res.message || 'Có lỗi xảy ra, vui lòng thử lại sau.'
            this.notiModal = true
          }
        } catch (error) {
          console.log(error)
          // Hiển thị modal thông báo lỗi
          this.isSuccess = false
          this.msgNoti = 'Có lỗi xảy ra, vui lòng thử lại sau.'
          this.notiModal = true
        } finally {
          this.loading = false
        }
      },
      async fetchData() {
        try {
          this.loading = true
          const res = await AgentService.getDetailAgentPartner(this.entryId)
          if (res.code === 1000) {
            this.dataDetail = res.data || {}
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },

      formatDate(dateString) {
        if (!dateString) return ''
        const date = new Date(dateString)
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const year = date.getFullYear()

        return `${hours}:${minutes} ${day}/${month}/${year}`
      },
    },
  }
</script>

<style scoped>
  .form-inner-heading {
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }

  .placeholder-box {
    background-color: #f0f0f0;
    border-radius: 4px;
  }

  .btn-group .btn {
    margin-left: 5px;
  }

  .badge-success {
    background-color: #28a745;
    color: white;
  }

  .badge-danger {
    background-color: #dc3545;
    color: white;
  }

  .badge-warning {
    background-color: #ffc107;
    color: #212529;
  }

  .badge-secondary {
    background-color: #6c757d;
    color: white;
  }

  .file-box {
    padding: 8px 12px;
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    display: inline-block;
  }

  .file-box a {
    color: #007bff;
    text-decoration: none;
  }

  .breadcrumb-area {
    margin-bottom: 20px;
  }

  .breadcrumb-area h1 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 0;
  }

  .card {
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  }

  .contract-file-card {
    display: flex;
    background-color: white;
    border-radius: 6px;
    padding: 5px;
    border: 1px solid #e5e5e5;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    transition:
      transform 0.2s,
      box-shadow 0.2s;
    height: 100%;
  }

  .contract-file-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .file-icon {
    font-size: 28px;
    color: #e74c3c;
    margin-right: 12px;
    display: flex;
    align-items: center;
  }

  .file-info {
    flex: 1;
  }

  .file-name {
    font-size: 14px;
    /* margin-bottom: 8px; */
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .file-actions {
    display: flex;
    align-items: center;
  }

  .no-files-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 0;
  }

  .placeholder-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 150px;
    height: 150px;
    background-color: #f1f1f1;
    border-radius: 8px;
    color: #777;
  }

  .placeholder-icon {
    font-size: 48px;
    color: #aaa;
  }
</style>
